<!-- src/components/PaginationControl.vue -->
<template>
  <div class="pagination-controls">
    <!-- previous -->
    <button
        class="page-arrow"
        :disabled="currentPage === 1"
        @click="$emit('update:currentPage', currentPage - 1)"
    >
      <font-awesome-icon :icon="['fas','fa-angles-left']" />
    </button>

    <!-- page numbers -->
    <button
        v-for="page in visiblePages"
        :key="page"
        class="page-number"
        :class="{ 'active-page': page === currentPage }"
        @click="$emit('update:currentPage', page)"
    >
      {{ page }}
    </button>

    <!-- next -->
    <button
        class="page-arrow"
        :disabled="currentPage === pageCount"
        @click="$emit('update:currentPage', currentPage + 1)"
    >
      <font-awesome-icon :icon="['fas','fa-angles-right']" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'PaginationControl',
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    pageCount: {
      type: Number,
      required: true
    },
    maxVisible: {
      type: Number,
      default: 3
    }
  },
  computed: {
    visiblePages() {
      // half-window on each side
      const delta = Math.floor(this.maxVisible / 2);
      let start = this.currentPage - delta;
      let end   = start + this.maxVisible - 1;

      // clamp to [1, pageCount]
      if (start < 1) {
        start = 1;
        end = Math.min(this.pageCount, this.maxVisible);
      }
      if (end > this.pageCount) {
        end = this.pageCount;
        start = Math.max(1, this.pageCount - this.maxVisible + 1);
      }

      // build the array
      const pages = [];
      for (let p = start; p <= end; p++) {
        pages.push(p);
      }
      return pages;
    }
  }
};
</script>

<style scoped>
.pagination-controls {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.page-arrow,
.page-number {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.3rem 0.5rem;
}
.page-number.active-page {
  font-weight: bold;
  text-decoration: underline;
}
.page-arrow:disabled,
.page-number:disabled {
  opacity: 0.5;
  cursor: default;
}
</style>
